module.exports = __webpack_public_path__ + "static/media/Indie.c4eb191c.mp3";